import EverTrue from 'app';
import { Icon, Tooltip2 } from '@evertrue/et-components';
import PropTypes from 'prop-types';
import { useGlobalJourneyProvider } from 'apps/journeys/context/global-journey-context';
import { isBulkMessageType } from 'apps/cadences-v2/utils/cadence-enums';

const ActiveJourneyPill = ({
  activeCadence: {
    journey_name,
    step_number,
    day_number,
    journey_id,
    current_due_date,
    owner,
    task_source,
    cadenceType,
  } = {},
  type,
  contactName,
}) => {
  const baseClass = type === 'profile' ? 'profile-header--cadence' : 'tasks-table--cadence';
  const { setNavigateFrom } = useGlobalJourneyProvider();
  const isV2 = task_source === 'cadence_v2';
  const className = isV2 ? `${baseClass} ${baseClass}-v2` : baseClass;

  const activeCadenceObj = {
    journey_name,
    step_number,
    day_number,
    current_due_date,
    owner,
    contact_name: contactName,
  };

  let route;
  if (isV2) {
    route = isBulkMessageType(cadenceType) ? `/cadences-v2/bulk-message/${journey_id}` : `/cadences-v2/${journey_id}`;
  } else {
    route = `/cadences/${journey_id}`;
  }

  let label;
  if (isV2) {
    label = journey_name || 'View Cadence';
  } else {
    label = `${journey_name} - Step ${step_number} | Day ${day_number}`;
  }

  return (
    <Tooltip2
      trigger={
        <div
          className={className}
          onClick={() => {
            if (!isV2) setNavigateFrom(activeCadenceObj);
            EverTrue.Navigator(route, true);
          }}
        >
          <Icon iconKit="gt2" icon="cadences"></Icon>
          <p>{label}</p>
        </div>
      }
    >
      {isV2 ? 'Cadence 2.0' : 'Cadence 1.0'}
    </Tooltip2>
  );
};

export default ActiveJourneyPill;

ActiveJourneyPill.propTypes = {
  activeCadence: PropTypes.shape({
    journey_name: PropTypes.string,
    step_number: PropTypes.number,
    day_number: PropTypes.number,
    current_due_date: PropTypes.string,
    owner: PropTypes.object,
    task_source: PropTypes.string,
    cadenceType: PropTypes.string,
  }),
  type: PropTypes.oneOf(['profile', 'tasks']),
  contactName: PropTypes.string,
};
